import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { resLogged, setLoggedIn } from '../../redux/slices/userSlice';
import LatinaController from '../../API/LatinaController';
import { SubmitHandler, useForm } from 'react-hook-form';
import Field from '../../components/Field/Field';
import { UserService } from '../../services/user.service';
import SButton from '../../components/UI/Button/SButton';
import BrandLogo from '../../components/UI/BrandLogo/BrandLogo';

import './SignUp.scss';

interface MainProps {
  title?: string;
}

export interface ISignUpForm {
  login: string
  name: string
  email: string
  phone: string
  date: string
  linkVk: string
  promo: string
}

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SignUp: FC<MainProps> = ({
  title = "Регистрация"
}) => {

  const loggedIn = useAppSelector((state) => state.usersR.loggedIn)
  const token = useAppSelector((state) => state.usersR.token)
  const userName = useAppSelector((state) => state.usersR.user.fio)
  const dispatch = useAppDispatch();

  const [sendDisable, setSendDisable] = useState(false);

  const { register: formRegister, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ISignUpForm>({ mode: "onChange" })

  let query = useQuery();

  let navigate = useNavigate();

  useEffect(() => {

    auth()

    const login = query.get("login") || ''
    const name = query.get("name") || ''
    const email = query.get("email") || ''
    const phone = query.get("phone") || ''
    const date = query.get("date") || ''
    const linkVk = query.get("linkVk") || ''
    const promo = query.get("promo") || ''
    setValue('login', login)
    setValue('name', name)
    setValue('email', email)
    setValue('phone', phone)
    setValue('date', date)
    setValue('linkVk', linkVk)
    setValue('promo', promo)

  }, [])


  const auth = async () => {
    try {
      const profile = await UserService.getProfile()
    } catch (e) {
      localStorage.removeItem('token')
      dispatch(setLoggedIn(false));
      dispatch(resLogged());
      navigate('/');
    }
  }

  const AuthApp = async (data: ISignUpForm) => {
    await AuthBase(data)

  }

  const titleM = title;
  const Auth = (data: ISignUpForm) => {

    const username = data.login
    const fio = data.name
    const email = data.email
    const phone = data.phone
    const birthday = data.date
    const link_vk = data.linkVk
    const password = process.env.REACT_APP_DEFAULT_PASSWORD

    const dataSend = {
      username,
      password,
      email,
      phone,
      fio,
      birthday,
      link_vk,
      nickname: username,
      number: 1,
      prefix: 'U',
      balance: 0,
    }

    fetch(`${process.env.REACT_APP_DOM}/api/users/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(dataSend)
    })
      .then((res) => {
        if (res.status >= 400) {
          const response = async () => await res.json()
          response().then(result => {
            alert(`
              Ошибка:
              Логин - ${result.username ? result.username[0] : ''};
              Почта - ${result.email ? result.email[0] : ''};
              Телефон - ${result.phone ? result.phone[0] : ''};
              Дата рождения - ${result.birthday ? result.birthday[0] : ''};
              `)

          })
          return false
        } else {
          return res.json()
        }
      })
      .then(dataUser => {
        if (dataUser != false) {


          dataUser.number = dataUser.id
        }
        return dataUser
      })
      .then(dataUser => {
        if (dataUser != false) {

          const dataStu = {
            number: dataUser.id,
            prefix: 'STU',
            id_users: dataUser.id,
            direction: '',
            subscrip: '',
            info: JSON.stringify({ info: dataUser.fio })
          }


          fetch(`${process.env.REACT_APP_DOM}/api/student/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Token ${token}`,
            },
            body: JSON.stringify(dataStu)
          })
        }
        return dataUser
      })
      .then(dataUser => {
        if (dataUser != false) {
          const loginUser = data.login
          const fio = data.name
          const email = data.email
          const phone = data.phone
          const birthday = data.date
          const link_vk = data.linkVk

          const password = process.env.REACT_APP_DEFAULT_PASSWORD


          const dataSendLog = {
            login: process.env.REACT_APP_USER_ONE,
            message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Пароль - ${password}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
          }

          const resLog = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram/log-write`, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataSendLog)
          })

          const dataSend = {
            login: process.env.REACT_APP_USER_ONE,
            message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Пароль - ${password}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
          }

          const res = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataSend)
          })

          const dataSend2 = {
            login: process.env.REACT_APP_USER_TWO,
            message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Пароль - ${password}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
          }


          const res2 = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataSend2)
          })

          const dataSend3 = {
            login: process.env.REACT_APP_USER_THREE,
            message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Пароль - ${password}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
          }


          const res3 = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataSend3)
          })


          alert(
            `Пользователь ${fio} добавлен
              Логин - ${loginUser}
              Пароль - ${password}
              `)
        }
      })
      .catch(e => {
        console.log('user-sign-up', e)
      })
  }

  const AuthBase = async (data: ISignUpForm) => {
    const dataSend = {
      data
    }

    let resUser

    try {
      resUser = await LatinaController.userCreate(dataSend)
      console.log('resUser', resUser)

      const loginUser = data.login
      const fio = data.name
      const link_vk = data.linkVk



      const dataSendLog = {
        login: process.env.REACT_APP_USER_ONE,
        message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
      }



      const resLog = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram/log-write`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataSendLog)
      })

      const dataSendTel = {
        login: process.env.REACT_APP_USER_ONE,
        message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
      }



      const res = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataSendTel)
      })

      const dataSend2 = {
        login: process.env.REACT_APP_USER_TWO,
        message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
      }


      const res2 = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataSend2)
      })

      const dataSend3 = {
        login: process.env.REACT_APP_USER_THREE,
        message: `Пользователь ${fio} добавлен
Логин - ${loginUser}
Профиль ВК: ${link_vk}
Добавил преподаватель: ${userName}
`
      }


      const res3 = fetch(`${process.env.REACT_APP_DOM_SEND}/ipa/v2/bot-telegram`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataSend3)
      })

      alert(
        `Пользователь ${fio} добавлен
          Логин - ${loginUser}
          Пароль - ${process.env.REACT_APP_DEFAULT_PASSWORD}
          `)

      reset()


    } catch (e: any) {
      console.log('Error', e)
      if (e) {
        if (e.response.data.message.text) {
          alert(e.response.data.message.text)
        } else {
          alert(JSON.stringify(e.response.data))
        }
      }
    }

    if (resUser) {
      console.log('ХОРОШО')
    } else {
      console.log('ПЛОХО')
    }
  }


  const AuthClose = () => {
    navigate('/')
  }

  const validLogin = /^[a-zA-Z0-9_-]+$/
  const validName = /^[а-яА-ЯёЁ -]+$/
  const validEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const validPhone = /^[0-9]{11}$/
  const validDate = /^[0-9]{4}-[0-1]{1}[0-9]{1}-[0-3]{1}[0-9]{1}$/

  const onSubmit: SubmitHandler<ISignUpForm> = (data) => {
    AuthApp(data)
  }

  return (
    <div className="registration">
      <div className='registration__content'>
        <div className='registration__content-wrapper'>
          <BrandLogo />
          <div className='registration__content-box'>
            <div>
              {titleM}
            </div>
            {loggedIn ?
              <div className='registration-form'>
                <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column' }} >

                  <Field
                    {...formRegister('login', {
                      required: 'Логин обязательное поле',
                      pattern: {
                        value: validLogin,
                        message: 'Допустимы латиница, _ и -'
                      }
                    })}
                    placeholder='ironman'
                    label='Логин'
                    error={errors.login?.message}
                  />

                  <Field
                    {...formRegister('name', {
                      required: 'ФИО обязательное поле',
                      pattern: {
                        value: validName,
                        message: 'Допустимы кириллица, -, пробел'
                      }
                    })}
                    placeholder='Иванов Иван Иваныч'
                    label='ФИО'
                    error={errors.name?.message}
                  />

                  <Field
                    {...formRegister('email', {
                      required: 'Email обязательное поле',
                      pattern: {
                        value: validEmail,
                        message: 'Некорректный формат почты'
                      }
                    })}
                    placeholder='ironman@gmail.com'
                    label='Почта'
                    error={errors.email?.message}
                  />

                  <Field
                    {...formRegister('phone', {
                      required: 'Телефон обязательное поле',
                      pattern: {
                        value: validPhone,
                        message: 'Допустимы только цифры'
                      }
                    })}
                    placeholder='88001234567'
                    label='Телефон'
                    error={errors.phone?.message}
                  />

                  <Field
                    {...formRegister('date', {
                      required: 'Дата рождения обязательное поле',
                      pattern: {
                        value: validDate,
                        message: 'Формат обязателен: ГГГГ-ММ-ДД'
                      }
                    })}
                    placeholder='2023-01-31'
                    label='Дата рождения'
                    error={errors.date?.message}
                  />

                  <Field
                    {...formRegister('linkVk')}
                    placeholder='https://vk.com/id1'
                    label='Профиль vk'
                    error={errors.linkVk?.message}
                  />

                  <Field
                    {...formRegister('promo')}
                    label='Дополнительное поле'
                    error={errors.promo?.message}
                  />


                  <div>
                    <SButton disabled={sendDisable} type='submit'>Зарегистировать</SButton>

                  </div>
                </form>
              </div>
              :
              <SButton onClick={AuthClose}>Войти</SButton>
            }
            <div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
